import { render, staticRenderFns } from "./PurchaseOrderProcess.vue?vue&type=template&id=0106b7f8&"
import script from "./PurchaseOrderProcess.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports